module.exports = __webpack_public_path__ + "static/media/onion.26bc5a65.png";